import { createContext, useContext } from "react";

export interface BuyerData {
	id: string;
	name: string;
	slug: string;
}

export interface VendorProfile {
	id: string;
	user_id: string;
	external_user_id: string;
	email: string | null;
	first_name: string;
	last_name: string;
	phone_number: string | null;
	company: string;
	external_org_id: string | null;
	external_org_name: string | null;
}

export interface BuyerContextValue {
	buyer: BuyerData | null;
	vendorProfile: VendorProfile | null;
	isLoading: boolean;
	error: Error | null;
}

// Context to provide buyer data to child routes
export const BuyerContext = createContext<BuyerContextValue | null>(null);

export function useBuyerContext(): BuyerData {
	const context = useContext(BuyerContext);
	if (!context) {
		throw new Error("useBuyerContext must be used within VendorBuyerLayout");
	}
	if (context.isLoading) {
		throw new Error("BuyerContext is still loading");
	}
	if (context.error || !context.buyer) {
		throw new Error("BuyerContext has no buyer data");
	}
	return context.buyer;
}

export function useBuyerContextState(): BuyerContextValue {
	const context = useContext(BuyerContext);
	if (!context) {
		throw new Error("useBuyerContextState must be used within VendorBuyerLayout");
	}
	return context;
}

export function useVendorProfile(): VendorProfile {
	const context = useContext(BuyerContext);
	if (!context) {
		throw new Error("useVendorProfile must be used within VendorBuyerLayout");
	}
	if (context.isLoading) {
		throw new Error("BuyerContext is still loading");
	}
	if (!context.vendorProfile) {
		throw new Error("No vendor profile data");
	}
	return context.vendorProfile;
}
